
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("44FvL", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $8EyOs = parcelRequire("8EyOs");

/**
 * @generated SignedSource<<05b5d2d5333b5bbbbbd46e76719e7f00>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2c45a28008d540eb$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "RendererContentState_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "isDraft",
                        "value": false
                    }
                ],
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "contentState",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "restrictionLevel"
                    }
                ],
                "storageKey": "contentState(isDraft:false)"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "format",
                        "value": "USER_FRIENDLY"
                    }
                ],
                "concreteType": "ConfluenceDate",
                "kind": "LinkedField",
                "name": "contentStateLastUpdated",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ],
                "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
            }
        ],
        "type": "Content"
    };
}();
$2c45a28008d540eb$var$node.hash = "0f9f2dde9d4be6b365b2ad0a7bb7d408";
var $2c45a28008d540eb$export$2e2bcd8739ae039 = $2c45a28008d540eb$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $3IBnw = parcelRequire("3IBnw");


var $jMyy4 = parcelRequire("jMyy4");


var $aJv6Q = parcelRequire("aJv6Q");


var $9wGTI = parcelRequire("9wGTI");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");


var $qP1yw = parcelRequire("qP1yw");








var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

const $02b5fb906cf465ad$var$styling = (0, $buxP3.xcss)({
    borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    display: 'inline-block',
    width: '1px',
    height: '16px',
    marginBlock: 'space.0',
    marginRight: 'space.050',
    marginLeft: 'space.100',
    alignSelf: 'center'
});
const $02b5fb906cf465ad$export$9bdbf4502c13e864 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            testId: "vertical-line",
            xcss: $02b5fb906cf465ad$var$styling
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};


const $a8f24b4bd469814d$export$ca1cd2433610b201 = (0, $2c45a28008d540eb$export$2e2bcd8739ae039);
const $a8f24b4bd469814d$var$RendererContentStateContent = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId, isDraft: isDraft, hasSeparator: hasSeparator, contentState: contentState, reload: reload } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== contentState || $[2] !== hasSeparator || $[3] !== isDraft) {
        t1 = contentState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $qP1yw.LazyRendererContentStateComponent), {
            contentId: contentId,
            contentState: contentState,
            isDraft: isDraft
        }), !isDraft && hasSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02b5fb906cf465ad$export$9bdbf4502c13e864), null));
        $[0] = contentId;
        $[1] = contentState;
        $[2] = hasSeparator;
        $[3] = isDraft;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== reload) {
        t2 = reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
            name: "content-state",
            types: [
                (0, $c0urc.ReloadType).content
            ],
            reload: reload
        });
        $[5] = reload;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
};
const $a8f24b4bd469814d$var$RendererContentStateFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { contentId: contentId, isDraft: isDraft, hasSeparator: hasSeparator, contentFragmentRef: contentFragmentRef } = t0;
    const content = (0, $6SsN4.useFragment)($a8f24b4bd469814d$export$ca1cd2433610b201, contentFragmentRef);
    if (!content) return null;
    let t1;
    if ($[0] !== content.contentState || $[1] !== contentId || $[2] !== hasSeparator || $[3] !== isDraft) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8f24b4bd469814d$var$RendererContentStateContent, {
            contentId: contentId,
            isDraft: isDraft,
            hasSeparator: hasSeparator,
            contentState: content.contentState
        });
        $[0] = content.contentState;
        $[1] = contentId;
        $[2] = hasSeparator;
        $[3] = isDraft;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};
const $a8f24b4bd469814d$var$RendererContentStateQuery = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { contentId: contentId, isDraft: isDraft, hasSeparator: hasSeparator } = t0;
    let t1;
    if ($[0] !== contentId || $[1] !== isDraft) {
        t1 = {
            fetchPolicy: "cache-and-network",
            variables: {
                contentId: contentId,
                isDraft: isDraft,
                format: "USER_FRIENDLY"
            }
        };
        $[0] = contentId;
        $[1] = isDraft;
        $[2] = t1;
    } else t1 = $[2];
    const { data: data, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8EyOs.default), {
        ...t1,
        __callerPackage__: "content-state"
    });
    if (!data) return null;
    const contentState = data?.singleContent?.contentState;
    const t2 = contentState ?? null;
    let t3;
    if ($[3] !== contentId || $[4] !== hasSeparator || $[5] !== isDraft || $[6] !== refetch || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8f24b4bd469814d$var$RendererContentStateContent, {
            contentId: contentId,
            isDraft: isDraft,
            hasSeparator: hasSeparator,
            contentState: t2,
            reload: refetch
        });
        $[3] = contentId;
        $[4] = hasSeparator;
        $[5] = isDraft;
        $[6] = refetch;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
};
const $a8f24b4bd469814d$export$f29be0a8efdebc38 = (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { contentFragmentRef: contentFragmentRef, isDraft: isDraft } = props;
    if (!isDraft && contentFragmentRef && (0, $9wGTI.fg)("confluence_vp_meta_frag_reader")) {
        let t0;
        if ($[0] !== contentFragmentRef || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8f24b4bd469814d$var$RendererContentStateFragmentReader, {
                ...props,
                contentFragmentRef: contentFragmentRef
            });
            $[0] = contentFragmentRef;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    let t0;
    if ($[3] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a8f24b4bd469814d$var$RendererContentStateQuery, props);
        $[3] = props;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
const $a8f24b4bd469814d$export$cbe74da24be93fbd = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($a8f24b4bd469814d$export$f29be0a8efdebc38);
module.exports["RendererContentState_content"] = $a8f24b4bd469814d$export$ca1cd2433610b201;
module.exports["RendererContentStateImpl"] = $a8f24b4bd469814d$export$f29be0a8efdebc38;
module.exports["RendererContentState"] = $a8f24b4bd469814d$export$cbe74da24be93fbd;

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<dd6200b047aed134b0d9af6a992daf7b>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("qP1yw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $lJswu = parcelRequire("lJswu");


var $dzxx6 = parcelRequire("dzxx6");


const $d4d6077acc6972b1$export$a5601a59fc831df9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qET7f",
    name: "LazyEditorContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("w8thv"))).EditorContentStateComponent;
    },
    loading: (0, $lJswu.ContentStateSkeleton)
});

const $d4d6077acc6972b1$export$c49c9d91fa2cc91e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "OYB6O",
    name: "LazyRendererContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("ejQ8j"))).RendererContentStateComponent;
    },
    loading: (0, $dzxx6.RendererContentStatePlaceholder)
});
module.exports["LazyEditorContentStateComponent"] = $d4d6077acc6972b1$export$a5601a59fc831df9;
module.exports["LazyRendererContentStateComponent"] = $d4d6077acc6972b1$export$c49c9d91fa2cc91e;

});

parcelRegister("lJswu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $668f42f1e7477ee9$export$ad2edbf08e0f7b11 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "60px",
            height: "20px",
            isShimmering: true,
            testId: "content-state-skeleton"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentStateSkeleton"] = $668f42f1e7477ee9$export$ad2edbf08e0f7b11;

});

parcelRegister("dzxx6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kA6Zo = parcelRequire("kA6Zo");

const $62a49c8d20755563$var$loadingPlaceholderStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    minHeight: '32px',
    borderRadius: 'radius.small',
    paddingRight: 'space.100',
    backgroundColor: 'utility.elevation.surface.current'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$ContentStateNamePlaceholderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1kk5Tkf7mX _0fKRyPnQyn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62a49c8d20755563$var$contentStateColorPlaceholderStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.full',
    height: '10px',
    width: '10px',
    marginLeft: 'space.050',
    marginRight: 'space.075',
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$flexWrapperStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.075',
    marginRight: 'space.075'
});
const $62a49c8d20755563$export$6679211e6c7373d = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { contentState: contentState } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $62a49c8d20755563$var$contentStateColorPlaceholderStyles,
            testId: "subtle-renderer-content-state-color-placeholder"
        });
        $[0] = t1;
    } else t1 = $[0];
    const t2 = contentState?.name;
    let t3;
    if ($[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $62a49c8d20755563$var$flexWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            as: "li",
            alignItems: "center",
            xcss: $62a49c8d20755563$var$loadingPlaceholderStyles,
            testId: "subtle-renderer-content-state-placeholder"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($62a49c8d20755563$var$ContentStateNamePlaceholderWrapper, null, t2)));
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
};
module.exports["RendererContentStatePlaceholder"] = $62a49c8d20755563$export$6679211e6c7373d;

});

parcelRegister("w8thv", function(module, exports) {

let $06098f7e4d821e1f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $06098f7e4d821e1f$var$load("2tyj0"),
    $06098f7e4d821e1f$var$load("5lkzC"),
    $06098f7e4d821e1f$var$load("8tibH"),
    $06098f7e4d821e1f$var$load("6WPx8"),
    $06098f7e4d821e1f$var$load("aP4DK"),
    $06098f7e4d821e1f$var$load("4XkGy"),
    $06098f7e4d821e1f$var$load("9J1M7"),
    $06098f7e4d821e1f$var$load("dgerE"),
    $06098f7e4d821e1f$var$load("h4Nf7"),
    $06098f7e4d821e1f$var$load("7wlV6"),
    $06098f7e4d821e1f$var$load("el56J"),
    $06098f7e4d821e1f$var$load("6wr18"),
    $06098f7e4d821e1f$var$load("59hV4"),
    $06098f7e4d821e1f$var$load("agq8T"),
    $06098f7e4d821e1f$var$load("8MPlE"),
    $06098f7e4d821e1f$var$load("4x9Jx"),
    $06098f7e4d821e1f$var$load("iWnyc"),
    $06098f7e4d821e1f$var$load("ea3NB"),
    $06098f7e4d821e1f$var$load("9cpj1"),
    $06098f7e4d821e1f$var$load("fuOfV"),
    $06098f7e4d821e1f$var$load("jL1Ke"),
    $06098f7e4d821e1f$var$load("5MQ0D"),
    $06098f7e4d821e1f$var$load("6vqGz"),
    $06098f7e4d821e1f$var$load("ffEVr"),
    $06098f7e4d821e1f$var$load("iMohY"),
    $06098f7e4d821e1f$var$load("3SirY"),
    $06098f7e4d821e1f$var$load("Wowvf"),
    $06098f7e4d821e1f$var$load("2l8zo"),
    $06098f7e4d821e1f$var$load("f3wA3"),
    $06098f7e4d821e1f$var$load("7q3P3"),
    $06098f7e4d821e1f$var$load("hhss7"),
    $06098f7e4d821e1f$var$load("7EorR"),
    $06098f7e4d821e1f$var$load("9DDT5")
]).then(()=>parcelRequire('2TweP'));

});

parcelRegister("ejQ8j", function(module, exports) {

let $a6cb4794d1294ded$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6cb4794d1294ded$var$load("jcEo4").then(()=>parcelRequire('llcSD'));

});


//# sourceMappingURL=RendererContentState.2a4a69e1.js.map
